// This is a hack to get the width of the input value.
// It creates a span with the same style as the input and measures the width.

export default function inputValueWidth (input) {
  const span = document.createElement('span')
  const style = window.getComputedStyle(input)

  span.textContent = input.value || input.placeholder || ''
  span.style.position = 'absolute'
  span.style.visibility = 'hidden'
  span.style.whiteSpace = 'pre'
  span.style.font = style.font // includes weight, size, family, etc.

  document.body.appendChild(span)
  const width = span.getBoundingClientRect().width
  span.remove()

  return width
}
